import { STATUS_DETAILS } from "../ducks/consts";

// Gravado pelo PDV legado e, quando passar a gravar, pelo "Entregue" do Hub.
// Não vira etapa na tela: só encerra o pedido.
const CONCLUDED = "CONCLUDED";

// Ordem em que a API grava os eventos do pedido (pallas-api, `changeStatus`):
// cada transição só sai de um estado anterior, então um evento adiante implica
// os de trás. A loja pode pular etapa (o despacho em lote do Hub vai do
// confirmado direto ao despachado, inclusive na retirada), e a tela não pode
// ficar esperando um evento que não vem mais. Ver docs/status-do-pedido.md.
const ORDEM_DOS_EVENTOS = [
  STATUS_DETAILS.PAYMENT.code, // INTEGRATED
  STATUS_DETAILS.CONFIRMED.code,
  STATUS_DETAILS.READY_TO_DELIVER.code,
  STATUS_DETAILS.DISPATCHED.code,
  CONCLUDED,
];

// Até onde o pedido chegou: a posição do evento mais adiantado, -1 sem nenhum.
function alcance(status) {
  return status.reduce(
    (maior, evento) => Math.max(maior, ORDEM_DOS_EVENTOS.indexOf(evento.code)),
    -1,
  );
}

/**
 * Etapas da tela de status. O delivery termina no despacho e não mostra o
 * "pronto" (READY_TO_DELIVER), que o Hub grava antes de despachar; retirada e
 * mesa terminam no "pronto".
 */
export function etapasDoPedido({ toDelivery, comPagamento }) {
  return [
    STATUS_DETAILS.DONE,
    ...(comPagamento ? [STATUS_DETAILS.PAYMENT] : []),
    STATUS_DETAILS.CONFIRMED,
    toDelivery ? STATUS_DETAILS.DISPATCHED : STATUS_DETAILS.READY_TO_DELIVER,
  ];
}

/**
 * Cada etapa com o `evento` que a cumpriu (é dele o horário) e se está
 * `feita`: tem o evento ou um evento adiante já chegou. A primeira etapa, o
 * pedido realizado, é o próprio `pedido`.
 */
export function andamentoDoPedido(etapas, status, pedido) {
  const chegou = alcance(status);
  return etapas.map((etapa) => {
    if (etapa.code === STATUS_DETAILS.DONE.code) {
      return { ...etapa, evento: pedido, feita: true };
    }
    const evento = status.find((s) => s.code === etapa.code) || null;
    const posicao = ORDEM_DOS_EVENTOS.indexOf(etapa.code);
    return {
      ...etapa,
      evento,
      feita: !!evento || (posicao >= 0 && posicao <= chegou),
    };
  });
}

/**
 * Até onde a tela acompanha o pedido. No autoatendimento, o pagamento
 * confirmado (é o que as telas do totem e do QR Code esperam); nos outros
 * modos, a última etapa mostrada.
 */
export function codigoFinalDoPedido({ isSelfcheckout, toDelivery }) {
  if (isSelfcheckout) return STATUS_DETAILS.CONFIRMED.code;
  const etapas = etapasDoPedido({ toDelivery, comPagamento: false });
  return etapas[etapas.length - 1].code;
}

/** Nada mais a acompanhar: cancelado, ou chegou ao `codigoFinal` ou além. */
export function pedidoEncerrado(status, codigoFinal) {
  if (status.some((s) => s.code === STATUS_DETAILS.CANCELLED.code)) {
    return true;
  }
  const final = ORDEM_DOS_EVENTOS.indexOf(codigoFinal);
  return final >= 0 && alcance(status) >= final;
}
